import { useStore } from '@stores';
import { useEffect, useMemo } from 'react';

interface IProps {
  orderId: string;
  skipCount?: number;
  maxResultCount?: number;
}

export const useOrderDocuments = ({
  orderId,
  skipCount = 0,
  maxResultCount = 50,
}: IProps) => {
  const { orderStore } = useStore();
  const { serviceOrderDocuments } = orderStore;

  useEffect(() => {
    orderStore.getAllDocuments({
      orderId,
      skipCount,
      maxResultCount,
    });
  }, [orderStore, skipCount, maxResultCount, orderId]);

  const documentItems = serviceOrderDocuments?.items || [];

  const documents = useMemo(
    () => documentItems.filter((item) => item.type === 'Document'),
    [documentItems]
  );

  const videos = useMemo(
    () => documentItems.filter((item) => item.type === 'Video'),
    [documentItems]
  );

  const images = useMemo(
    () => documentItems.filter((item) => item.type === 'Image'),
    [documentItems]
  );

  return { documents, videos, images };
};
